/* eslint-disable max-len */
import { i18n } from '@/modules/localization';
import { computed } from 'vue';
import { getTipoUsuario } from '@/modules/shared/storage';
import { TipoUsuario } from '@/modules/shared/tipoUsuario';

const traducao = (chave, quantidade) => computed((_) => i18n.global.t(chave, quantidade));

const menus = [
  {
    title: traducao('dashboard'),
    icon: 'bi-speedometer2',
    group: 'dashboards',
    submenu: [
      { icon: 'bi bi-cash-coin', title: traducao('assinatura', 1), to: '/dashboards/assinar', roles: [TipoUsuario.COMUM] },
      { icon: 'bi-table', title: traducao('listaDeOS'), to: '/dashboards/visionone', roles: [TipoUsuario.COMUM] },
      { icon: 'bi-table', title: traducao('listagemOS'), to: '/dashboards/listagemOS', roles: [TipoUsuario.COMUM] },
      { icon: 'bi-people-fill', title: traducao('cliente', 2), to: '/dashboards/clientes', roles: [TipoUsuario.COMUM] },
      { icon: 'bi-speedometer2', title: traducao('graficoDeVendas'), to: '/dashboards/visiontwo', roles: [TipoUsuario.COMUM] },
      { icon: 'bi-ticket', title: traducao('ticketMedioDeVendas'), to: '/dashboards/visionthree', roles: [TipoUsuario.COMUM] },
      { icon: 'bi-bar-chart-line', title: traducao('rankingDeServicos'), to: '/dashboards/visionfour', roles: [TipoUsuario.COMUM] },
      { icon: 'bi-bar-chart-line-fill', title: traducao('rankingDeProdutos'), to: '/dashboards/visionfive', roles: [TipoUsuario.COMUM] },
    ],
  },
  {
    title: traducao('administracao'),
    icon: 'bi-journals',
    group: 'admin',
    submenu: [
      { icon: 'bi-building', title: traducao('empresasPessoas'), to: '/admin/empresas', roles: [TipoUsuario.ADMIN, TipoUsuario.SUPORTE] },
      { icon: 'bi-bar-chart-steps', title: traducao('estatistica', 2), to: '/admin/estatisticas', roles: [TipoUsuario.ADMIN] },
      { icon: 'bi-people', title: traducao('usuario', 2), to: '/admin/usuarios', roles: [TipoUsuario.ADMIN, TipoUsuario.SUPORTE] },
      { icon: 'bi-list-nested', title: traducao('assinatura', 2), to: '/admin/assinaturas', roles: [TipoUsuario.ADMIN] },
      { icon: 'bi-cash-coin', title: traducao('receita', 2), to: '/admin/receitas', roles: [TipoUsuario.ADMIN] },
      { icon: 'bi-cash-coin', title: traducao('exPagantes'), to: '/admin/exPagantes', roles: [TipoUsuario.ADMIN] },
      { icon: 'bi-cash-stack', title: traducao('comissao'), to: '/admin/comissao', roles: [TipoUsuario.ADMIN] },
      { icon: 'bi-person-vcard', title: traducao('parceiro', 2), to: '/admin/parceiros', roles: [TipoUsuario.ADMIN] },
      { icon: 'bi bi-bell', title: traducao('notificacao'), to: '/admin/notificacao', roles: [TipoUsuario.ADMIN] },
      { icon: 'bi-chat-right-text', title: traducao('comentario', 2), to: '/admin/feedback', roles: [TipoUsuario.ADMIN, TipoUsuario.SUPORTE] },
      { icon: 'bi-journal-text', title: traducao('logs'), to: '/admin/logs', roles: [TipoUsuario.SUPORTE] },
    ],
  },
];

export const getMenu = () => {
  const tipoUsuario = getTipoUsuario();

  return menus
    .map((menu) => ({
      ...menu,
      submenu: menu.submenu.filter(({ roles }) => roles.includes(tipoUsuario)),
    }))
    .filter(({ submenu }) => submenu.length > 0);
};

export default getMenu;
